import { ChipProps } from '@mui/material/Chip';

/**
 * Assigns a color to a tag based on its content.
 * This helps in maintaining a consistent color for the same tag.
 * @param tag The tag string.
 * @returns A MUI Chip color prop.
 */
export const getTagColor = (tag: string): ChipProps['color'] => {
  // Simple hashing function to get a deterministic color
  let hash = 0;
  for (let i = 0; i < tag.length; i++) {
    hash = tag.charCodeAt(i) + ((hash << 5) - hash);
  }

  const colors: ChipProps['color'][] = ['primary', 'secondary', 'error', 'warning', 'info', 'success'];
  const index = Math.abs(hash % colors.length);
  return colors[index];
};